import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOrdersWithUpsell = {
  name: "getOrdersWithUpsell" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
  output: z.object({
    ordersWithUpsell: z.array(
      z.object({
        date: zExt.instant(),
        redoOrderId: zExt.objectId(),
        orderNumber: z.string(),
        upsellAmount: z.number(),
      }),
    ),
    totalCount: z.number(),
  }),
};
export type GetOrdersWithUpsellOutput = z.infer<
  typeof getOrdersWithUpsell.output
>;
